import { UpdatableModel } from './updatable-model';

export class SelectOption extends UpdatableModel<SelectOption> {
  text: string;
  value: any;
  disabled: boolean;
}
